import React, { Component } from 'react';
import 'react-table/react-table.css';
import './AppPage.css';
import { browserHistory } from 'react-router';

class AccountsMobile extends Component {
  constructor(props) {
    super(props);
    const tableSize = props.data && props.data.length > 0 ? props.data.length : 4;
    this.state = {
      tableSize,
      data: this.props.data,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState(
      {
        tableSize: nextProps.data.length === 0 ? 4 : nextProps.data.length,
        data: nextProps.data,
      },
      function() {
        this.forceUpdate();
      }
    );
  }

  goToTicket = ticket_number => {
    browserHistory.push(`/companies/edit_ticket?ticket_number=${ticket_number}`);
  };

  render() {
    return (
      <div className="mobile_card">
        {this.state.data.length === 0 && (
          <div id="mobile_card">
            <div className="row">
              <p
                style={{
                  textAlign: 'center',
                  color: 'rgba(0,0,0,0.5)',
                  marginTop: '13px',
                }}
              >
                {' '}
                You don&rsquo;t have any vendors{' '}
              </p>
            </div>
          </div>
        )}
        {this.state.data.map((file, i) => (
          <div id="mobile_card" key={i} onClick={() => this.goToTicket(file.ticket_number)}>
            <div className="row">
              <div className="mobile_header"> {file.name}</div>
              <div style={{ float: 'right', marginTop: '4px' }}>
                <span style={{ fontSize: '10px', color: 'grey' }}>{file.classification}</span>
              </div>
            </div>
            <div className="row">
              <div className="mobile_subheader">{file.amount_outstanding} outstanding</div>
            </div>
            <div className="row" style={{ marginTop: '3px' }}>
              <div className="mobile_subheader">{file.notes}</div>
            </div>
          </div>
        ))}
      </div>
    );
  }
}

export default AccountsMobile;
